
import { EMAIL_ID, LOYALTY_ID } from 'contexts/CruiseSearchContext/constants';
import { BrandCode } from 'types';

const getPromoCodeParam = (brandCode, quickBooking) => {
    if (brandCode === BrandCode.RoyalCaribbean || !!quickBooking) {
        return 'promoCode=#{promocode}';
    }

    if (brandCode === BrandCode.Celebrity) {
        return 'pCD=#{promocode}';
    }
}

function getBookingLinkPromoParams(qualifiersApplied, loyaltyId, email, { brand } = {}, quickBooking = false) {
    const promoCode = qualifiersApplied?.filter(qualifier => qualifier.indexOf('coupon:') === 0)
      .map(coupon => coupon.split('|').find(item => item.indexOf('coupon:') === 0).replace('coupon:', ''))
      .join(',');

    const promoCodeParam = getPromoCodeParam(brand?.code, quickBooking);

    const promoParam = promoCode ? `&${promoCodeParam.replace('#{promocode}', promoCode)}` : '';
    const loyaltyParam = loyaltyId
        ? `&${LOYALTY_ID.bookingParam}=${loyaltyId}`
        : '';
    const emailParam = email && !quickBooking
        ? `&${EMAIL_ID.bookingParam}=${encodeURIComponent(email)}`
        : '';

    return `${promoParam}${loyaltyParam}${emailParam}`;
}

export default getBookingLinkPromoParams;
